<template>
  <component
    :is="tag"
    class="play-list"
    :class="{ 'play-list--flush': flush }"
  >
    <slot />
  </component>
</template>

<script>
/**
 * PlayList — grouped list container for the Play system.
 *
 * Token-driven (see src/styles/tokens.scss). Replaces bootstrap-vue's
 * <b-list-group>. Holds <PlayListItem>s in a bordered, rounded card; `flush`
 * drops the outer border/radius so it sits edge-to-edge inside another surface.
 * Renders a <div> by default, or `tag="ul"` for a semantic list.
 *
 * VUE3-MIGRATION: nothing Vue 2-specific — already Vue 3-safe.
 */
export default {
  name: 'PlayList',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    /** Remove the outer border/radius (edge-to-edge) */
    flush: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.play-list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
  background: var(--surface-card);
  border: var(--border-w) solid var(--border-ink);
  border-radius: var(--radius-lg);
  overflow: hidden;

  &--flush {
    border: 0;
    border-radius: 0;
    background: transparent;
  }
}
</style>
